import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              瓜友热评
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              来自真实用户的吃瓜体验分享
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {comments.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200/70 rounded-lg p-5 flex flex-col"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="min-w-0">
                    <div className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</div>
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-foreground-400">{item.time}</span>
                      <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-[10px] rounded-sm whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  &ldquo;{item.content}&rdquo;
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line w-3 h-3 flex items-center justify-center"></i>
                  <span>{item.likes.toLocaleString()}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}